import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { item as TrackingItem } from 'c9-tracking';
import { getValue } from '../../components/values/Get';

/**
 * You're covered
 * @param formConfig
 * @param value
 */
export const trackUpload = (formConfig: FormConfig, formValues: FormValues, elementId: string) => {
    const items: TrackingItem[] = [];

    const value = getValue(formConfig, formValues, elementId);
    if (value.files.length > 0) {
        items.push({ key: 'number-of-uploaded-files', value: value.files.length });
    } else if (value.customerDidNotUploadReason === 'Jeg har ingen dokumentation') {
        items.push({ key: 'user-selected-no-documentation', value: true });
    } else if (value.customerDidNotUploadReason === 'Jeg uploader dokumentation senere') {
        items.push({ key: 'user-selected-upload-later', value: true });
    }
    return items;
};
